import {Directive} from '@angular/core';

/* To override a default toggle icon */
@Directive({
    selector: '[ngxMatTimepickerToggleIcon]',
    standalone: true
})

export class NgxMatTimepickerToggleIconDirective {
}
